'use strict';

function UserService($resource, config) {
  return $resource(config.apiBase + '/users/:userId', {}, {
    'update': { method:'PUT' },
    'createInvite': {
      method:  'POST',
      isArray: false,
      url:     config.apiBase + '/users/invite'
    },
    'createAliasEmail': {
      method:  'POST',
      isArray: false,
      url:     config.apiBase + '/users/:userId/alias'
    },
    'setMainEmail': {
      method:  'GET',
      url:     config.apiBase + '/users/:userId/alias/:aliasId/main'
    },
    'getAliasEmail': {
      method:  'GET',
      isArray: true,
      url:     config.apiBase + '/users/:userId/alias'
    },
    'getActivateAlias': {
      method:  'GET',
      url:     config.apiBase + '/users/activate-alias'
    }
  });
}

angular.module('dokiv')
  .factory('UserService', ['$resource', 'config', UserService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/user/UserService.js
// module id = 21
// module chunks = 0